import { motion } from "framer-motion";
import { SectionHead } from "./SectionHead";
import { fadeUp, staggerWrap } from "./shared";
import { ABOUT_IMG, PROCESS } from "../lib/site";

const VALUES = [
    { t: "Diagnosi prima delle cure", d: "Prima cerchiamo la causa, poi interveniamo. Nessuna toppa a caso." },
    { t: "Cantiere pulito, sempre", d: "Protezioni, teli e ripristino: ti consegniamo la superficie, non il disordine." },
    { t: "Garanzia scritta", d: "Ogni intervento è documentato e coperto da garanzia su carta." },
];

export default function About() {
    return (
        <section id="azienda" className="relative py-24 md:py-32 bg-panel/40 border-y border-white/5" data-testid="about-section">
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    <div>
                        <SectionHead
                            id="azienda"
                            eyebrow="Chi siamo"
                            title={
                                <>
                                    Specialisti in una sola cosa:{" "}
                                    <span className="text-aqua">tenere l&rsquo;acqua fuori.</span>
                                </>
                            }
                        />
                        <motion.div
                            variants={staggerWrap}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <motion.p variants={fadeUp} className="text-ash leading-relaxed text-base sm:text-lg">
                                Edil Loffredo nasce come azienda specializzata esclusivamente in
                                impermeabilizzazioni e coperture. Non siamo l&rsquo;impresa che fa tutto:
                                siamo quella che fa bene un mestiere solo, e lo dimostra su ogni cantiere.
                            </motion.p>
                            <motion.p variants={fadeUp} className="mt-5 text-ash leading-relaxed text-base sm:text-lg">
                                Dalla guaina bituminosa alla resina continua, lavoriamo con materiali
                                certificati e sistemi applicativi collaudati — su terrazzi e
                                lastrici solari di ogni dimensione.
                            </motion.p>

                            <motion.ul variants={staggerWrap} className="mt-10 space-y-5">
                                {VALUES.map((v) => (
                                    <motion.li key={v.t} variants={fadeUp} className="flex gap-4" data-testid="about-value">
                                        <span className="mt-1.5 w-2 h-2 shrink-0 bg-ambra" />
                                        <div>
                                            <h3 className="font-display font-semibold tracking-tight text-lg text-cloud">
                                                {v.t}
                                            </h3>
                                            <p className="text-sm text-ash mt-1 leading-relaxed">{v.d}</p>
                                        </div>
                                    </motion.li>
                                ))}
                            </motion.ul>
                        </motion.div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                        className="relative"
                    >
                        <div className="spotlight frame-clipped border border-white/10" data-testid="about-image-frame">
                            <img
                                src={ABOUT_IMG}
                                alt="Terrazzo con finitura continua in resina"
                                loading="lazy"
                                className="w-full h-[420px] md:h-[560px] object-cover img-treated"
                            />
                        </div>
                        <div className="absolute -bottom-5 left-6 bg-ambra text-bitume px-5 py-3 frame-clipped-sm" data-testid="about-badge">
                            <span className="font-mono2 text-[10px] uppercase tracking-[0.22em] font-semibold">
                                Il risultato: superficie asciutta
                            </span>
                        </div>
                    </motion.div>
                </div>

                <motion.ol
                    variants={staggerWrap}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.2 }}
                    className="mt-20 md:mt-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
                    data-testid="process-steps"
                >
                    {PROCESS.map((p) => (
                        <motion.li key={p.n} variants={fadeUp} className="border-t-2 border-white/10 pt-5 group hover:border-ambra transition-colors duration-500">
                            <span className="font-mono2 text-xs text-ambra">{p.n}</span>
                            <h3 className="font-display font-semibold tracking-tight text-xl text-cloud mt-2">{p.t}</h3>
                            <p className="text-sm text-ash mt-2 leading-relaxed">{p.d}</p>
                        </motion.li>
                    ))}
                </motion.ol>
            </div>
        </section>
    );
}
